'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card2Data from '../../../textContent/manufacturing/cardTwo.json';
import card3Data from '../../../textContent/manufacturing/cardThree.json';
import cardData from '../../../textContent/manufacturing/cardOne.json';
import { motion } from 'framer-motion';

/* ---------------- Animation Variant ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const Page = () => {
    const heroTextContent = {
        heading:
            'Top Manufacturing ERP Software & Providers in Kochi, Kerala & Bangalore',
        caption:
            'Get expert ERPNext solutions for manufacturing businesses. Wahni delivers setup, customization, and support across Kochi, Kerala, and Bangalore, offering trusted Manufacturing ERP Software for efficient operations.',
        image: '/images/hero/manufacturing.png',
        buttonText: 'Contact Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero Section */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero {...heroTextContent} width="3/5" />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
            >
                <VideoTextCard
                    data={card3Data}
                    bgColor="bg-[#ccf4c7] bg-opacity-40"
                    btnColor="bg-[#52d34d]"
                />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
            >
                <VideoTextCard
                    data={cardData}
                    bgColor="bg-[#D2E0FB] bg-opacity-40"
                    btnColor="bg-[#528ff6]"
                    borderColor=" border-[#528ff6]"
                />
            </motion.div>

            {/* Card 3 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
            >
                <VideoTextCard
                    data={card2Data}
                    bgColor="bg-[#E5E0FF] bg-opacity-40"
                    btnColor="bg-[#313bb2]"
                    borderColor=" border-[#313bb2]"
                />
            </motion.div>
        </Fragment>
    );
};

export default Page;
